import { createCurrentModule, createCurrentSelector } from '@beef/redux';
import { emptyArr, emptyObj } from '@beef/utils';
import { createSelector } from '@reduxjs/toolkit';
import { TARIFF_TYPES } from '@fttb/common/constants';
import { getCheckAddressRequestData } from "../../checkAddress/selectors";
import { getSelectedAddress, getViewStatus } from "../addressVerification/moduleSelectors";
import { getConnectionStatus } from "../../../components/OrderTariffFormPopup/OrderTariffFormOldPopup/store/selectors/orderTariffCommon";
import { getQueryParams } from "../../../components/OrderTariffFormPopup/OrderTariffFormOldPopup/utils/utils";
import { POPUP_CONNECTION_STATE } from "../../common/constants";
import { selectHouseInacId } from "../../../components/OrderTariffFormPopup/OrderTariffFormInlinePopup/store/selectors";
import { tariffValueGroup, tariffValueKind } from "../constants";
import { getIsAuthFlag } from "../../shared/selectors";
import { getTariffsData, getTariffsList, selectIsLoadingTariffButton } from "./selectors";
var _createCurrentSelecto = createCurrentSelector(getTariffsList, function (item) {
    return item.alias;
  }),
  CurrentTariffProvider = _createCurrentSelecto.CurrentProvider,
  __ = _createCurrentSelecto.selectCurrent,
  withTariffMapper = _createCurrentSelecto.withCurrentProviderMapper;
export { CurrentTariffProvider, __, withTariffMapper };
var selectCurrentTariff = __;
export var getIsLinkFlag = function getIsLinkFlag(state) {
  return selectCurrentTariff(state).isLink || false;
};
export var getTariffValues = function getTariffValues(state) {
  return selectCurrentTariff(state).values || emptyArr;
};
export var getTariffTitle = function getTariffTitle(state) {
  return selectCurrentTariff(state).title;
};
export var getTextColor = function getTextColor(state) {
  return selectCurrentTariff(state).textColor;
};
export var getTariffGroup = function getTariffGroup(state) {
  return selectCurrentTariff(state).group;
};
export var getTariffInacId = function getTariffInacId(state) {
  return selectCurrentTariff(state).inacId;
};
export var getIsPresetUpFlag = function getIsPresetUpFlag(state) {
  return selectCurrentTariff(state).isPresetUp;
};
export var getTariffImageSrc = function getTariffImageSrc(state) {
  return selectCurrentTariff(state).image;
};
export var getTariffImageWidth = function getTariffImageWidth(state) {
  return selectCurrentTariff(state).imageWidth;
};
export var getTariffBgColor = function getTariffBgColor(state) {
  return selectCurrentTariff(state).bgColor;
};
export var getTariffDescription = function getTariffDescription(state) {
  return selectCurrentTariff(state).description;
};
export var getTariffAction = function getTariffAction(state) {
  return selectCurrentTariff(state).action;
};
export var getTariffFee = function getTariffFee(state) {
  return selectCurrentTariff(state).fee || emptyObj;
};
export var getTariffOldFee = function getTariffOldFee(state) {
  return selectCurrentTariff(state).oldFee || emptyObj;
};
export var getTariffUrl = function getTariffUrl(state) {
  return selectCurrentTariff(state).detailsUrl;
};
export var getTariffParameters = function getTariffParameters(state) {
  return selectCurrentTariff(state).parameters || emptyArr;
};
export var getTariffType = function getTariffType(state) {
  return selectCurrentTariff(state).type;
};
export var getIsUniConstructorTariffFlag = function getIsUniConstructorTariffFlag(state) {
  return selectCurrentTariff(state).isUniversalConstructor;
};
export var getTariffAlias = function getTariffAlias(state) {
  return selectCurrentTariff(state).alias;
};
export var getTariffTags = function getTariffTags(state) {
  return selectCurrentTariff(state).tags || emptyArr;
};
export var getTariffIcons = function getTariffIcons(state) {
  return selectCurrentTariff(state).icons || emptyArr;
};
export var getIsMyTariff = function getIsMyTariff(state) {
  return selectCurrentTariff(state).isConnected;
};
export var getTariffButtonText = function getTariffButtonText(state) {
  return selectCurrentTariff(state).buttonText || getTariffsData(state).buttonText;
};
export var getIsTariffUp = function getIsTariffUp(state) {
  return selectCurrentTariff(state).isTariffUp;
};
export var selectIsLoadingTariffButtonFlag = createSelector([selectIsLoadingTariffButton, getTariffInacId], function (_ref, targetInacId) {
  var inacId = _ref.inacId,
    isLoad = _ref.isLoad;
  return targetInacId === inacId && isLoad;
});
export var getTariffTypeWithPresetUp = createSelector([getIsPresetUpFlag, getTariffType], function (isPresetUp, type) {
  return isPresetUp && type !== TARIFF_TYPES.partnerFmc ? TARIFF_TYPES.presetUp : type;
});
export var selectIsFttbTariffType = createSelector([getTariffType], function (tariffType) {
  return [TARIFF_TYPES.internet, TARIFF_TYPES.kit].includes(tariffType);
});
export var selectHidePointerEventFlag = createSelector([getIsAuthFlag, getTariffTypeWithPresetUp], function (isAuth, type) {
  return isAuth || type === TARIFF_TYPES.partnerFmc;
});
export var TariffModule = createCurrentModule({
  selectTariff: selectCurrentTariff
});
export var getIsHighSpeedTariff = createSelector([getTariffValues], function (values) {
  return values.filter(function (item) {
    return item.group === tariffValueGroup.home && item.kind === tariffValueKind.speed;
  }).some(function (item) {
    return Number(item.value) > 100;
  });
});
export var getHighSpeedAvailableFlag = createSelector([getConnectionStatus, getIsHighSpeedTariff], function (status, isHighSpeedTariff) {
  return isHighSpeedTariff && status === POPUP_CONNECTION_STATE.highSpeedAvailable;
});

// параметры для формирования урл в деталку из карты проверки адреса (улица, дом, квартира)
export var buildOrderQueryParams = createSelector([getTariffInacId, getCheckAddressRequestData, getSelectedAddress, getHighSpeedAvailableFlag, selectHouseInacId, getViewStatus], function (inacId, addressDataMap, addressDataVerificationAddress, isHighSpeedAvailable, houseInacId, status) {
  if ((!(addressDataMap !== null && addressDataMap !== void 0 && addressDataMap.streetId) || !addressDataMap.houseId) && (!(addressDataVerificationAddress !== null && addressDataVerificationAddress !== void 0 && addressDataVerificationAddress.house_fias_id) || !(addressDataVerificationAddress !== null && addressDataVerificationAddress !== void 0 && addressDataVerificationAddress.street_with_type)) || !inacId) {
    return null;
  }
  return getQueryParams({
    inacId: inacId,
    houseInacId: houseInacId,
    street: addressDataMap.street || (addressDataVerificationAddress === null || addressDataVerificationAddress === void 0 ? void 0 : addressDataVerificationAddress.street_with_type),
    streetId: addressDataMap.streetId || (addressDataVerificationAddress === null || addressDataVerificationAddress === void 0 ? void 0 : addressDataVerificationAddress.settlement_with_type),
    house: addressDataMap.house || (addressDataVerificationAddress === null || addressDataVerificationAddress === void 0 ? void 0 : addressDataVerificationAddress.house),
    houseId: addressDataMap.houseId || (addressDataVerificationAddress === null || addressDataVerificationAddress === void 0 ? void 0 : addressDataVerificationAddress.house_fias_id),
    flat: addressDataMap.flat || (addressDataVerificationAddress === null || addressDataVerificationAddress === void 0 ? void 0 : addressDataVerificationAddress.flat),
    value: addressDataVerificationAddress === null || addressDataVerificationAddress === void 0 ? void 0 : addressDataVerificationAddress.value,
    status: status,
    isHighSpeedAvailable: isHighSpeedAvailable
  });
});
export var getTariffHref = createSelector([buildOrderQueryParams, getTariffUrl], function (urlParams, tariffUrl) {
  return urlParams ? "".concat(tariffUrl, "?").concat(urlParams) : tariffUrl;
});